export default __webpack_public_path__ + "static/media/sambusa.a0f882ae.jpg";